/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDataStorageUnitKey { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The Business Object Format Version for a previously registered Business Object Format
     */
    businessObjectFormatVersion?: number;
    /**
     * The Partition Value that this Business Object Data is associated with
     */
    partitionValue: string;
    /**
     * A list of Sub-Partition values this Business Object Data is associated with
     */
    subPartitionValues?: Array<string>;
    /**
     * The numeric version of a Business Object Data
     */
    businessObjectDataVersion?: number;
    /**
     * The name of the storage
     */
    storageName: string;
}
